import MultipleImageField from "./MultipleImageField"

export default MultipleImageField
